"use client";
import styled from "styled-components";
import Title from "@/components/Title";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Button from "@/components/Button";
import { Loading } from "@/components/Loading";
import { useEffect, useState } from "react";
import axios from "axios";

const ContactForm = ({ data }) => {
  const [IsSubmitting, setIsSubmitting] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsSubmitting(false);
    }, 300);
  }, []);

  const { register, handleSubmit, formState, reset } = useForm({ mode: "all" });
  const { errors, isSubmitSuccessful, isSubmitting } = formState;

  //--- form submit

  const success = (msg) =>
    toast.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const error = (msg) =>
    toast.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const onSubmit = async (data) => {
    setIsSubmitting(true); // Show spinner
    try {
      const formData = new FormData();
      formData.append("_wpcf7_unit_tag", "form_" + "3979");
      formData.append("your-name", data?.name);
      formData.append("email", data?.email);
      formData.append("phone", data?.phone);
      formData.append("message", data?.message);

      const response = await axios.post(
        "https://cms.ucbstock.com.bd//wp-json/contact-form-7/v1/contact-forms/3979/feedback",
        formData
      );
      if (response.status === 200) {
        success(response?.data?.message);
        reset(); // Reset form fields
      } else {
        error("Failed to submit form. Please try again later.");
      }
    } catch (err) {
      error(
        err?.message
          ? err?.message
          : "Failed to submit form. Please try again later."
      );
    } finally {
      setIsSubmitting(false); // Hide spinner
    }
  };

  const onError = (errors) => {
    // setToastShown(false); // Reset toast shown state on new submission attempt
    const firstError = Object.values(errors)[0];
    error(firstError.message);
  };

  return (
    <StyledContactForm
      className={"pt-200 pb-200 horizontal-scroll"}
      data-speed-right={30}
      data-speed-left={-30}
    >
      {IsSubmitting && <Loading />}
      <Container>
        <p className={"parallax-xr bg-text-one"}>CONTACT</p>
        <p className={"parallax-x bg-text-two"}>US</p>
        <Row>
          <Col md={4}>
            <Title text={"Contact Us"} />
          </Col>
          <Col md={8}>
            <Form className={"form"} onSubmit={handleSubmit(onSubmit, onError)}>
              <div className="form-group">
                <Form.Group controlId="formBasicEmail">
                  <Form.Control
                    className={
                      formState?.errors?.name?.message
                        ? "has-error form-control-lg"
                        : "form-control-lg"
                    }
                    {...register("name", {
                      required: "Enter your full name",
                      pattern: {
                        value: /^[A-Za-z ]+$/,
                        message: "Name must contain only letters",
                      },
                    })}
                    type="text"
                    placeholder="Name*"
                    disabled={isSubmitting}
                  />
                  {errors.name && (
                    <span className="error-message form-error">
                      {errors.name.message}
                    </span>
                  )}
                </Form.Group>
              </div>
              <div className="phoneEmail">
                <div className="form-group">
                  <Form.Group controlId="formBasicEmail">
                    <Form.Control
                      className={
                        formState?.errors?.email?.message
                          ? "has-error form-control-lg"
                          : "form-control-lg"
                      }
                      {...register("email", {
                        required: {
                          value: true,
                          message: "Enter a valid email address",
                        },
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Enter a valid email address",
                        },
                      })}
                      type="email"
                      placeholder="Email*"
                      disabled={isSubmitting}
                    />
                    {errors.email && (
                      <span className="error-message form-error">
                        {errors.email.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
                <div className="form-group">
                  <Form.Group controlId="formBasicPhone">
                    <Form.Control
                      className={
                        formState?.errors?.phone?.message
                          ? "has-error form-control-lg"
                          : "form-control-lg"
                      }
                      {...register("phone", {
                        required: {
                          value: true,
                          message: "Enter your phone number",
                        },
                        pattern: {
                          value: /^01[0-9]{9}$/,
                          message: "Enter a valid 11 digit phone number",
                        },
                      })}
                      type="number"
                      placeholder="Phone Number*"
                      disabled={isSubmitting}
                    />
                    {errors.phone && (
                      <span className="error-message form-error">
                        {errors.phone.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="form-group">
                <Form.Group controlId="formBasicPhone">
                  <Form.Control
                    as="textarea"
                    rows={4}
                    className={
                      formState?.errors?.message?.message
                        ? "has-error form-control-lg"
                        : "form-control-lg"
                    }
                    {...register("message", {
                      required: {
                        value: true,
                        message: "Enter your Message",
                      },
                    })}
                    // type="textarea"
                    placeholder="Message*"
                    disabled={isSubmitting}
                  />
                  {errors.message && (
                    <span className={"form-error error-message"}>
                      {errors.message?.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div
                className={`form-group width-fit ${
                  isSubmitting ? "disabled" : ""
                }`}
              >
                <div
                  style={{ width: "fit-content" }}
                  onClick={handleSubmit(onSubmit, onError)}
                >
                  <Button src={"javascript:void(0)"} text={"Submit"} />
                </div>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </StyledContactForm>
  );
};

const StyledContactForm = styled.section`
  background-color: #f4f4f4;
  position: relative;

  .form-group {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .form-control {
      box-shadow: none;
      outline: 0;
      border-radius: 0;
      background: transparent;
      height: auto;
      border-left: none;
      border-right: none;
      border-top: none;
      border-color: rgba(198, 198, 198, 0.5);
      padding: 0 0 8px;
      color: #3c3c3b;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;

      &:focus {
        border-color: #3c3c3b;
      }

      &::placeholder {
        color: #c6c6c6;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    textarea {
      min-height: 80px;
    }
  }

  .phoneEmail {
    display: flex;
    gap: 25px;
    .form-group {
      flex: 0 0 49%;
    }
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 0px;
      .form-group {
        flex: 0 0 100%;
        &:last-child {
          margin-bottom: 30px;
        }
      }
    }
  }

  .bg-text-one,
  .bg-text-two {
    font-size: 200px;
    line-height: 250px;
    font-weight: 700;
    margin: 0;
    color: rgba(25, 25, 25, 0.05);
    position: absolute;
    white-space: nowrap;
    font-family: "Aeonik", Euclid Square, Arial, Helvetica, freesans, sans-serif;

    @media (max-width: 767px) {
      font-size: 120px;
      line-height: 120px;
    }
  }
  .bg-text-one {
    right: 0;
    top: 165px;
  }

  .bg-text-two {
    left: 600px;
    bottom: 125px;
  }

  @media (max-width: 767px) {
    padding-bottom: 60px;
    .bg-text-one,
    .bg-text-two {
      display: none;
    }
  }

  form {
    @media (max-width: 767px) {
      margin-bottom: 40px;
    }
  }
`;

export default ContactForm;
